import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { DirectivesModule } from '../../directives/directives.module';
import { OrderCompletePage } from './order-complete';

@NgModule({
  declarations: [OrderCompletePage],
  imports: [IonicPageModule.forChild(OrderCompletePage), DirectivesModule],
})
export class OrderCompletePageModule {}



// WEBPACK FOOTER //
// ./src/pages/order-complete/order-complete.module.ts